import {get, post, tuluPost,postAES} from "@/api/request"


export const getClass = params => get("/v1/home/pc/class/auctions", params)
export const auctionarr = params => postAES("/v3/session/detail", params)//拍卖会列表
export const agencyarr = params => post("/v1/organ/simple/info", params)//拍卖公司机构
export const getMeeting = params => postAES("/v3/organ/info", params)//机构详情
export const recommen = params => post("/v1/recommend/auction", params)//拍品推荐
export const captchaGenerate = params => post("/v2/common/captcha/generate", params)//验证码获取
export const captchaVerify = params => post("/v2/common/captcha/verify", params)//验证码校验

export const special = params => postAES("/v3/special/list", params)//拍品推荐
export const getMemType = params => tuluPost("/member/memberinfo", params)//获取会员类型
export const getMemToken = params => tuluPost("/member/passport/token", params)//获取会员Token
export const webCheckType = params => get('https://user-api.artron.net/api/device/web_check', params)
//在线竞拍按钮
export const onlineAuction = params => tuluPost("/app/session/catLogInfo",params)
export const postZoneSend = params => post("/v1/organ/zone/send/art", params)// 我要送拍
export const poauction = params => post("/v1/search/meta", params)// 我要送拍
export const setBidClick = params => post("/v1/special/bid/click", params)//点击参拍